<template>
  <!-- 基础数据-职位、部门角色公用 -->
  <div class="page-staff-person">
    <div class="wrap">
      <div class="button">
        <el-input
          style="width:250px;"
          placeholder="请输入手机号搜索"
          @keyup.enter.native="searchList"
          v-model="listQuery.phone"
        >
          <i slot="suffix" class="el-icon-search g-pointer" @click="searchList"></i>
        </el-input>
      </div>

      <!-- 表格 -->
      <div class="table mt-20">
        <el-table stripe :data="tableData" v-loading="listLoading">
          <el-table-column prop="userName" label="用户名" min-width="30%"></el-table-column>
          <el-table-column prop="phone" label="注册手机号" min-width="30%"></el-table-column>
          <el-table-column prop="createDate" label="注册时间" min-width="30%"></el-table-column>

          <el-table-column fixed="right" label="操作" min-width="10%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="join('join', scope.row.userId)">加入</a>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container">
          <el-pagination
            :current-page="listQuery.currentPage"
            :page-size="listQuery.size"
            :total="total"
            background
            layout="total, prev, pager, next, sizes, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>

    <dialogAddStaff ref="dialogAddStaff" :bussinessType="`staff`" @refresh="getDataList"></dialogAddStaff>
  </div>
</template>

<script>
import dialogAddStaff from './../dialog-add-staff'
export default {
  components: { dialogAddStaff },
  // watch: {
  //   $route(path) {
  //     this.pageType = path.query.pageType
  //     this.getDataList()
  //   }
  // },
  data() {
    return {
      // pageType: this.$route.query.pageType, // job:职位  department:部门角色
      tableData: [],
      listLoading: true,
      listQuery: {
        phone: '', // 手机号或姓名
        currentPage: 1,
        size: 10
      },
      total: 0
    }
  },
  methods: {
    // 初始化表格
    getDataList() {
      this.listLoading = true
      this.$http
        .get('/user/listApproval', {
          ...this.listQuery
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            this.tableData = res.result
            this.total = res.page.allRow
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 搜索
    searchList() {
      this.listQuery.currentPage = 1
      this.getDataList()
    },
    join(type, id) {
      this.$refs.dialogAddStaff.init(type, id)
    },
    // 新增职位
    add(item) {
      this.$prompt('', this.pageType === 'job' ? '职位名称' : '部门角色', {
        showClose: true,
        // showCancelButton: false,
        confirmButtonText: '确定',
        inputPlaceholder: '请输入',
        inputValue: (item && item.name) || null,
        // inputPattern: /^[\S]{1,10}$/,
        inputPattern: /^.{1,10}$/,
        inputErrorMessage: '请输入1到10位字符',
        center: true
      })
        .then(({ value }) => {
          if (!item) {
            this.addRemote(item, value)
          } else {
            this.editRemote(item, value)
          }
        })
        .catch(() => {})
    },
    edit(item) {
      this.add(item)
    },
    dele(id) {
      this.$common.confirm(
        {
          title:
            this.pageType === 'job'
              ? '您正在删除职位，是否确认删除？'
              : '您正在删除部门角色，是否确认删除？',
          className: 'cus-confirm-375'
        },
        () => {
          console.log('删除')
          this.$http
            .post('/job/delete', {
              id: id
            })
            .then(res => {
              if (res.success) {
                this.$message.success(
                  this.pageType === 'job' ? '删除职位成功' : '删除部门成功'
                )
                this.getDataList()
              } else {
                this.$message.error(res.message)
              }
            })
        }
      )
    },
    addRemote(item, value) {
      this.$http
        .post('/job/add', {
          type: this.pageType === 'job' ? 'job' : 'dept',
          name: value
        })
        .then(res => {
          if (res.success) {
            this.$message.success(
              this.pageType === 'job' ? '新增职位成功' : '新增部门成功'
            )
            this.getDataList()
          } else {
            this.$message.error(res.message)
          }
        })
    },
    editRemote(item, value) {
      this.$http
        .post('/job/update', {
          id: item.id,
          name: value
        })
        .then(res => {
          if (res.success) {
            this.$message.success(
              this.pageType === 'job' ? '编辑职位成功' : '编辑部门成功'
            )
            this.getDataList()
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initList()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initList()
    }
  },
  created() {
    this.getDataList()
  }
}
</script>

<style lang="scss" scoped>
.page-staff-person {
  .wrap {
    padding: 30px;
    background: #fff;
    box-shadow: 0px 1px 10px 0px rgba(238, 239, 245, 1);
    border-radius: 4px;
  }
}
</style>


